globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};
appCustomerSpace.Controllers.Settings.Crm = appCustomerSpace.Controllers.Settings.Crm || {};

appCustomerSpace.Controllers.Settings.Crm.BulkContactDeletionsController = (function(superClass) {

  utils.extend(BulkContactDeletionsController, superClass);

  function BulkContactDeletionsController() {
    return BulkContactDeletionsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(BulkContactDeletionsController.prototype, {
    index: function() {
      var controller = this;
      var $select = controller.$body.find("#bulk-deletion-list-select");
      var $preview = controller.$body.find(".bulk-deletion-preview");
      var $error = controller.$body.find(".bulk-deletion-error");
      var $submit = controller.$body.find(".bulk-deletion-submit");
      var previewUrl = $select.data("preview-url");

      $select.on("change", function() {
        var listUniqKey = $(this).val();

        $preview.empty();
        $error.attr("hidden", true);
        $submit.attr("disabled", true);

        if (listUniqKey === "") {
          return;
        }

        $.getJSON(previewUrl, { list_uniq_key: listUniqKey }, function(data) {
          $preview.html(data.html);
          $submit.attr("disabled", data.deletable === 0);
        }).fail(function() {
          $error.removeAttr("hidden");
        });
      });
    }
  });

  return BulkContactDeletionsController;

})(appCustomerSpace.Controllers.MainController);
